import React, { useCallback, useEffect, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "./navbar.scss";
import { useWeb3React } from "@web3-react/core";
import useAuth from "../../hooks/useAuth";
import Dropdown from "react-bootstrap/Dropdown";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Balance from "../../hooks/dataFetcher/BalanceOf";
import QRCode from "react-qr-code";
import {
  createPublicClient,
  createWalletClient,
  custom,
  slice,
  http,
} from "viem";
import useWeb3 from "../../hooks/useWeb3";
import axios from "axios";
import { useCheckAllowance } from "../../hooks/dataSender/Allowance";
import useApprove from "../../hooks/dataSender/Approval";
import { useTransfer } from "../../hooks/dataFetcher/transfer";
import Loader from "../../hooks/loader";
import { toast } from "react-toastify";
import {
  useEthInternalBalace,
  usePermisions,
  usePublicClient,
  userPrivateKey,
  userProfileState,
  userSmartAccount,
  userSmartAccountClient,
  useSmartSession,
} from "../recoilAtom";
import { useRecoilState, useRecoilValue } from "recoil";
import { generatePrivateKey, privateKeyToAccount } from "viem/accounts";
import {
  createBicoBundlerClient,
  createMeeClient,
  getSudoPolicy,
  meeSessionActions,
  smartSessionActions,
  toMultichainNexusAccount,
  toNexusAccount,
  toSmartSessionsModule,
} from "@biconomy/abstractjs";
import { bsc } from "viem/chains";
import getNodeUrl from "../../utils/getRpcUrl";
import BalanceOfAbi from "../../../src/utils/UsdtABI.json";

import {
  ethNullAddress,
  LUCKIFY_CONTRACT_ADDRESS,
  me_client_api_key,
  USDT_CONTRACT_ADDRESS,
  CRASH_GAME_CONTRACT,
  bundlers,
} from "../../utils/Enviroment";
import LuckifyABI from "../../utils/LuckifyABI.json";

import { encodeFunctionData, ethAddress, toFunctionSelector } from "viem";
import { BrowserProvider, ethers } from "ethers";
import useSignature from "../../hooks/userSign";
import WalletConnectModel from "../walletConnectModel";
import DepositModel from "../depositeModel";
import { LocalAccountSigner } from "@aa-sdk/core";
import {
  createSmartWalletClient,
  signPreparedCalls,
} from "@account-kit/wallet-client";
import { alchemy, sepolia, base } from "@account-kit/infra";
import { defineAlchemyChain } from "@account-kit/infra";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import backendClient from "../../utils/backendClient";
import { getData, saveData } from "../../utils/db.js";
import CryptoJS from "crypto-js";
import CreashGameAbi from "../../utils/CrashGameAbi.json";
import { WalletClientSigner } from "@aa-sdk/core";
import { getIndexKey } from "../indexDb.js";
import audioManager from "../../utils/AudioManajer.js";

const Header = ({ onToggleSidebar }) => {
  const [smartAccountClient, setSmartAccountClient] = useRecoilState(
    userSmartAccountClient
  );
  let addrSign = localStorage.getItem("sign");
  let logintime = localStorage.getItem("timeOfSign");
  let route = localStorage.getItem("route");
  const [smartAccount, setSmartAccount] = useRecoilState(userSmartAccount);
  const [sessionkey, setSessionKey] = useRecoilState(useSmartSession);
  const [permissions, setPermissions] = useRecoilState(usePermisions);
  const [PublicClient, setPublicClient] = useRecoilState(usePublicClient);
  const [privateKeyy, setPrivateKey] = useRecoilState(userPrivateKey);

  const [ethInteBlance, setEthInternalBlace] =
    useRecoilState(useEthInternalBalace);
  const { userLibrary } = useSignature();
  const { checkAllowance } = useCheckAllowance();
  const web3 = useWeb3();
  let { account } = useWeb3React();
  const { BalanceHook } = Balance();
  const chain = bsc;
  const RPC_URL = getNodeUrl();
  const [userBalance, setUserBalance] = useState(null);
  const [internalAccount, setInternalAccount] = useState(null);
  const [connected, setConnected] = useState(false);
  const [address, setAddress] = useState(false);
  const { login, logout } = useAuth();
  const [loader, setLoader] = useState(false);
  const router = useLocation();
  const [totalBalance, setTotalBlance] = useState(0);
  const [ethExternalBalance, setEthExternalBalance] = useState(null);
  const [userBalanceExternal, setUserBalanceExternal] = useState(null);
  const [localDdData, setLocalDbData] = useState(null);
  const [mute, setmute] = useState(false);
  var now11 = new Date();
  let createdDate = now11?.getTime();
  let currentTime = createdDate / 1000;

  const [loading, setLoading] = useState(false);
  const [loaderText, setLoaderText] = useState({
    heading: "Loading",
    paragraph: "",
  });
  const currentPath = router.pathname;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show1, setShow1] = useState(false);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const [theme, setTheme] = useState("light");
  const [mounted, setMounted] = useState(false);

  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);
  const [show2, setShow2] = useState(false);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [showWallet, setShowWallet] = useState(false);

  const handleCloseWallet = () => setShowWallet(false);
  const handleShowWallet = () => setShowWallet(true);

  const [accountSmart, setAccountSmart] = useState(null);
  const [newMclient, setNewMeClient] = useState(null);
  const history = useHistory();
  const profile = useRecoilValue(userProfileState);

  const disconnectWallet = async () => {
    const connectorId = window?.localStorage?.getItem("connectorId");
    await logout(connectorId);
    // localStorage.clear()
    localStorage.removeItem("connectorId");
    localStorage.removeItem("flag");
    localStorage.removeItem("signForAll");
    localStorage.removeItem("privateKey");
    localStorage.removeItem("placeBet");
    localStorage.removeItem("timeOfSign");
    localStorage.removeItem("sign");
    localStorage.removeItem("addrSign");
    // window.location.reload("/");
    // window.location.assign("/");

    Object.keys(localStorage).forEach((key) => {
      if (
        key.startsWith("wc@") ||
        key.startsWith("walletconnect") ||
        key.startsWith("WALLETCONNECT") ||
        key.includes("walletconnect") ||
        key.startsWith("wc_") ||
        key.startsWith("wcm_") // WalletConnect Modal
      ) {
        localStorage.removeItem(key);
      }
    });

    // Also clear sessionStorage items (WalletConnect sometimes uses this too)
    Object.keys(sessionStorage).forEach((key) => {
      if (
        key.startsWith("wc@") ||
        key.startsWith("walletconnect") ||
        key.startsWith("WALLETCONNECT") ||
        key.includes("walletconnect") ||
        key.startsWith("wc_") ||
        key.startsWith("wcm_")
      ) {
        sessionStorage.removeItem(key);
      }
    });

    // history.push("/");
  };
  const [isMuted, setIsMuted] = useState(() => {
    const muted = audioManager.getMuted();
    console.log("🎯 Header initial mute state:", muted);
    return muted;
  });

  const toggleMute = () => {
    console.log("👆 Toggle button clicked, current state:", isMuted);
    const newMutedState = !isMuted;
    setIsMuted(newMutedState);
    audioManager.setMuted(newMutedState);
    console.log("🔄 New mute state:", newMutedState);
  };

  useEffect(() => {
    console.log("🔗 Header mounting, subscribing to audioManager");

    const handleMuteChange = (muted) => {
      console.log("📨 Header received mute change:", muted);
      setIsMuted(muted);
    };

    audioManager.addListener(handleMuteChange);

    return () => {
      console.log("🔌 Header unmounting, unsubscribing");
      audioManager.removeListener(handleMuteChange);
    };
  }, []);

  useEffect(() => {
    const storedTheme = localStorage.getItem("theme") || "dark";
    setTheme(storedTheme);
    document.documentElement.setAttribute("data-theme", storedTheme);
    setMounted(true);
    // if (account) {

    //   dpDataHandler();
    //   // internalAccountHandler();
    // }
  }, [account, web3]);
  // useEffect(() => {
  //   if (account && localDdData) {
  //     internalAccountHandler();
  //   } else if (!smartAccount && account && !localDdData) {
  //     handleShowWallet();
  //   }
  // }, [smartAccount, localDdData, account]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (account && addrSign) {
        internalAccountHandler();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [addrSign, account]);

  // useEffect(() => {
  //   if (accountSmart && newMclient && sessionkey && permissoon) {
  //     callMe();
  //   }
  // }, [accountSmart, newMclient, sessionkey, permissoon]);
  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  if (!mounted) return null;

  const internalAccountHandler = async (value) => {
    try {
      // let privateKey = "";
      // const key = "CrashGame_";
      // if (!value) {
      //   let privatekey = await getData("privateKeyM");
      //   const myPrivateKey = privatekey
      //     ? CryptoJS.AES.decrypt(privatekey, key).toString(CryptoJS.enc.Utf8)
      //     : "";
      //   // let privatekey = localStorage.getItem("privateKeyM");
      //   privateKey = privatekey ? myPrivateKey : generatePrivateKey();
      // } else {
      //   privateKey = value;
      // }

      // const chain = defineAlchemyChain({
      //   chain: bsc,
      //   rpcBaseUrl:
      //     // "https://bnb-mainnet.g.alchemy.com/v2/rXuje7GuLST3ZQzaFMp-oBiP1Xfrjq75",
      //     "https://bnb-mainnet.g.alchemy.com/v2/hzq55lpr590lsryyehabgrt4finrp45n",
      // });

      // setPrivateKey(privateKey);
      // const privateKey =
      //   "0x15a2476665c785ac01945d1f3f650f9612e2b95f891179de02c49ddaec13ccaa";

      // const encrypted = CryptoJS.AES.encrypt(privateKey, key).toString();
      // await saveData("privateKeyM", encrypted);
      // const signer = LocalAccountSigner.privateKeyToAccountSigner(privateKey);
      const getLibrarySigner = userLibrary?.provider;
      const signer = new WalletClientSigner(
        createWalletClient({
          chain: base,
          transport: custom(getLibrarySigner),
        }),
        "wallet"
      );
      const client = createSmartWalletClient({
        transport: alchemy({ apiKey: process.env.REACT_APP_API_KEY }),
        chain: base,
        signer: signer,
        policyId: process.env.REACT_APP_POLICY_ID,
      });
      // client.prepareCalls();
      const smartAccountAddress = await client.requestAccount();
      setSmartAccount(smartAccountAddress.address);
      setSmartAccountClient(client);

      // const sessionKey = LocalAccountSigner.generatePrivateKeySigner();
      // const permissions = await client?.grantPermissions({
      //   account: smartAccountAddress.address,
      //   key: {
      //     publicKey: await sessionKey?.getAddress(),
      //     type: "secp256k1",
      //   },
      //   permissions: [{ type: "root" }],
      // });

      // setPermissions(permissions);
      // setSessionKey(sessionKey);

      const publicClient = createPublicClient({
        chain: base,
        transport: http(),
      });
      setPublicClient(publicClient);

      const balance = await BalanceHook(smartAccountAddress.address);
      const balance1 = await BalanceHook(account);
      setUserBalance(balance);
      setInternalAccount(smartAccountAddress.address);
      setUserBalanceExternal(balance1);
      // const balanceWei = await web3.eth.getBalance(account);
      // const balanceEth = web3.utils.fromWei(balanceWei, "ether");
      // const balanceWei1 = await web3.eth.getBalance(
      //   smartAccountAddress.address
      // );
      // const balanceEth1 = web3.utils.fromWei(balanceWei1, "ether");

      // setEthInternalBalance(balanceEth1);
      // setEthExternalBalance(balanceEth);
      // setEthInternalBlace(ethBalance);
      // console.log(
      //   +ethBalance + balance,
      //   ethBalance,
      //   balance,
      //   "ethBalance + balance)"
      // );
      // setEthInternalBlace(ethBalance);
      setTotalBlance(balance);
    } catch (error) {
      console.log(error, "error internal function erro");
    }
  };

  // const callMeWallet = async () => {
  //   const chain = defineAlchemyChain({
  //     chain: bsc,
  //     rpcBaseUrl: "https://bnb-mainnet.g.alchemy.com/v2/Kke4a-YEF4HDLnQB81F88",
  //   });
  //   // let privatekey = localStorage.getItem("privateKeyM");
  //   // const privateKey = privatekey ? privatekey : generatePrivateKey();
  //   const privateKey =
  //     "0x15a2476665c785ac01945d1f3f650f9612e2b95f891179de02c49ddaec13ccaa";

  //   const signer = LocalAccountSigner.privateKeyToAccountSigner(privateKey);

  //   //getting client here
  //   const client = createSmartWalletClient({
  //     transport: alchemy({ apiKey: "Kke4a-YEF4HDLnQB81F88" }),
  //     chain: chain,
  //     signer,
  //   });

  //   const smartAccountAddress = await client.requestAccount();
  //   console.log(privateKey, signer, client, smartAccountAddress.address);
  //   setSmartAccount(smartAccountAddress.address);
  //   setSmartAccountClient(client);

  //   const sessionKey = LocalAccountSigner.generatePrivateKeySigner();
  //   const permissions = await client?.grantPermissions({
  //     account: smartAccountAddress.address,
  //     key: {
  //       publicKey: await sessionKey?.getAddress(),
  //       type: "secp256k1",
  //     },
  //     permissions: [{ type: "root" }],
  //   });
  //   console.log(permissions, sessionKey);
  //   setPermissions(permissions);
  //   setSessionKey(sessionKey);

  //   // const callArgs = [
  //   //   {
  //   //     to: USDT_CONTRACT_ADDRESS,
  //   //     data: encodeFunctionData({
  //   //       abi: BalanceOfAbi,
  //   //       functionName: "approve",
  //   //       args: [LUCKIFY_CONTRACT_ADDRESS, 10000000000000000000000000000n],
  //   //     }),
  //   //   },
  //   // ];
  //   console.log(smartAccountAddress.address, permissions, client, "client");

  //   // const preparedCalls = await client.prepareCalls({
  //   //   calls: callArgs,
  //   //   from: smartAccountAddress.address,
  //   //   capabilities: {
  //   //     permissions,
  //   //   },
  //   // });
  //   // console.log(preparedCalls, "client");
  //   // setTimeout(async () => {
  //   //   const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
  //   //   console.log(signedCalls, "signedCalls");

  //   //   const { preparedCallIds } = await client.sendPreparedCalls({
  //   //     ...signedCalls,
  //   //     capabilities: {
  //   //       permissions,
  //   //     },
  //   //   });
  //   //   console.log(signedCalls, "client");
  //   //   const status = await client.getCallsStatus(preparedCallIds[0]);
  //   //   console.log(status, "status");
  //   // }, 30000);

  //   // const sessionKey = LocalAccountSigner.generatePrivateKeySigner();
  //   // console.log(sessionKey);

  //   // setSessionKey(sessionKey);
  //   // const userPermissions = await client?.grantPermissions({
  //   //   account: smartAccountAddress.address,
  //   //   key: {
  //   //     publicKey: await sessionKey?.getAddress(),
  //   //     type: "secp256k1",
  //   //   },
  //   //   permissions: [{ type: "root" }],
  //   // });
  //   // setperssion(userPermissions);
  //   // console.log(userPermissions, "permissions", sessionKey);

  //   // let arryvalue = [
  //   //   {
  //   //     to: USDT_CONTRACT_ADDRESS, // Target contract address
  //   //     data: encodeFunctionData({
  //   //       abi: BalanceOfAbi,
  //   //       functionName: "approve",
  //   //       args: [LUCKIFY_CONTRACT_ADDRESS, 10000000000000000n], // Approve a large amount for the create pool contract
  //   //     }),
  //   //   },
  //   // ];
  //   // const preparedCallss = await client.prepareCalls({
  //   //   calls: arryvalue,
  //   //   from: smartAccountAddress.address,
  //   //   capabilities: {
  //   //     userPermissions,
  //   //   },
  //   // });
  //   // console.log(permissoon, "preparedCalls");

  //   // const signedCalls = await signPreparedCalls(sessionkey, preparedCallss);
  //   // const { preparedCallIds } = await client.sendPreparedCalls({
  //   //   ...signedCalls,
  //   //   capabilities: {
  //   //     userPermissions,
  //   //   },
  //   // });
  //   // console.log(permissoon, signedCalls, "loggerrrrr");
  //   // const status = await newMclient.getCallsStatus(preparedCallIds[0]);
  //   // console.log("Call status:", status);
  // };

  // const callMePersion = async () => {
  //   const sessionKey = LocalAccountSigner.generatePrivateKeySigner();
  //   const permissions = await smartAccountClient?.grantPermissions({
  //     account: smartAccount,
  //     key: {
  //       publicKey: await sessionKey?.getAddress(),
  //       type: "secp256k1",
  //     },
  //     permissions: [{ type: "root" }],
  //   });
  //   console.log(permissions, sessionKey);
  //   setPermissions(permissions);
  //   setSessionKey(sessionKey);
  // };
  // const finalCall = async () => {
  //   const callArgs = [
  //     {
  //       to: USDT_CONTRACT_ADDRESS,
  //       data: encodeFunctionData({
  //         abi: BalanceOfAbi,
  //         functionName: "approve",
  //         args: [LUCKIFY_CONTRACT_ADDRESS, 10000000000n],
  //       }),
  //     },
  //   ];
  //   console.log(smartAccount, permissions);

  //   const preparedCalls = await smartAccountClient.prepareCalls({
  //     calls: callArgs,
  //     from: smartAccount,
  //     capabilities: {
  //       permissions,
  //     },
  //   });
  //   const signedCalls = await signPreparedCalls(sessionkey, preparedCalls);
  //   const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
  //     ...signedCalls,
  //     capabilities: {
  //       permissions,
  //     },
  //   });
  //   const status = await smartAccountClient.getCallsStatus(preparedCallIds[0]);
  //   console.log("Call status:", status);
  // };

  const tryCreatePoolTx = async (smartAccountClient, smartAccount) => {
    try {
      console.log("agaya gori");

      setLoading(true);
      const withDraw = slice(toFunctionSelector("withdraw(uint256)"), 0, 4);
      const addLiqudity = slice(toFunctionSelector("deposit(uint256)"), 0, 4);
      const approveSelector = slice(
        toFunctionSelector("approve(address,uint256)"),
        0,
        4
      );
      const placeBetSelector = slice(
        toFunctionSelector("placeBet(uint256,uint256)"),
        0,
        4
      );
      const cashoutSeclector = slice(
        toFunctionSelector("cashout(uint256)"),
        0,
        4
      );

      const sessionKey = LocalAccountSigner.generatePrivateKeySigner();
      console.log(sessionKey);

      const userPermissions = await smartAccountClient?.grantPermissions({
        account: smartAccount,
        key: {
          publicKey: await sessionKey?.getAddress(),
          type: "secp256k1",
        },
        permissions: [{ type: "root" }],
      });

      console.log(userPermissions, "permissions", sessionKey);

      const preparedCalls = await smartAccountClient.prepareCalls({
        calls: [
          {
            to: USDT_CONTRACT_ADDRESS, // Target contract address
            data: encodeFunctionData({
              abi: BalanceOfAbi,
              functionName: "approve",
              args: [
                LUCKIFY_CONTRACT_ADDRESS,
                10000000000000000000000000000000000000000n,
              ], // Approve a large amount for the create pool contract
            }),
          },
        ],
        from: smartAccount,
        capabilities: {
          preparedCalls,
        },
      });
      console.log(preparedCalls, "preparedCalls");

      const signedCalls = await signPreparedCalls(sessionKey, preparedCalls);
      const { preparedCallIds } = await smartAccountClient.sendPreparedCalls({
        ...signedCalls,
        capabilities: {
          preparedCalls,
        },
      });
      const status = await smartAccountClient.getCallsStatus(
        preparedCallIds[0]
      );
      console.log("Call status:", status);

      setLoading(false);

      // localStorage?.setItem("signForAll", JSON.stringify(userPermissions));
      // localStorage?.setItem("privateKey", JSON.stringify(sessionKey));
      // console.log("createSessionsResponse", createSessionsResponse);
      // const emulatedAccount = await toNexusAccount({
      //   accountAddress: nexusAccount.address, // The address that granted the permission
      //   signer: sessionSigner,
      //   chain,
      //   transport: viemHttp(RPC_URL),
      // });
      // // console.log("emulatedAccount: ", emulatedAccount);

      // const emulatedClient = createBicoBundlerClient({
      //   chain,
      //   account: emulatedAccount,
      //   transport: viemHttp(
      //     "https://bundler.biconomy.io/api/v3/56/bundler_3ZNf6pKi6WMQ8ScfAeWMfSxM"
      //   ),
      // });
      // console.log("emulatedClient: ", emulatedClient);

      // const smartSessionsClient = emulatedClient.extend(smartSessionActions());
      // try {
      //   const userOpHash = await smartSessionsClient.usePermission({
      //     sessionDetails: createSessionsResponse,
      //     calls: [
      //       {
      //         to: USDT_CONTRACT_ADDRESS, // Target contract address
      //         data: encodeFunctionData({
      //           abi: BalanceOfAbi,
      //           functionName: "approve",
      //           args: [CRASH_GAME_CONTRACT, 1000000000000000000000000n], // Approve a large amount for the create pool contract
      //         }),
      //       },
      //     ],
      //     mode: "ENABLE_AND_USE",
      //   });
      //   const receipt = await emulatedClient.waitForUserOperationReceipt({
      //     hash: userOpHash,
      //   });
      //   if (!receipt.success) {
      //     throw new Error("Smart sessions module validation failed");
      //   }

      //   console.log("Permission used successfully:", receipt);
      // } catch (error) {
      //   console.error("Error using permission:", error);
      // }
    } catch (err) {
      console.log(err);

      setLoading(false);
    }
  };

  // const tryCreatePoolTx = async (contractParams) => {
  //   try {
  //     setLoading(true);
  //     const privateKey = generatePrivateKey();
  //     const sessionSigner = privateKeyToAccount(privateKey);
  //     const withDraw = slice(toFunctionSelector("withdraw(uint256)"), 0, 4);
  //     const addLiqudity = slice(toFunctionSelector("deposit(uint256)"), 0, 4);
  //     const approveSelector = slice(
  //       toFunctionSelector("approve(address,uint256)"),
  //       0,
  //       4
  //     );
  //     const placeBetSelector = slice(
  //       toFunctionSelector("placeBet(uint256,uint256)"),
  //       0,
  //       4
  //     );
  //     const cashoutSeclector = slice(
  //       toFunctionSelector("cashout(uint256)"),
  //       0,
  //       4
  //     );
  //     const ethersProvider = new BrowserProvider(userLibrary.provider);
  //     const signer = await ethersProvider.getSigner(account);
  //     console.log("contractParams: ", contractParams);
  //     const nexusAccount = await toNexusAccount({
  //       signer: signer,
  //       transport: viemHttp(RPC_URL),
  //       chain,
  //     });

  //     const nexusClient = createBicoBundlerClient({
  //       chain: chain,
  //       account: nexusAccount,
  //       transport: viemHttp(bundlers),
  //     });
  //     const sessionsModule = toSmartSessionsModule({
  //       signer: signer,
  //     });

  //     console.log("sessionsModule: ", sessionsModule);

  //     const isModuleInstalled = await nexusClient.isModuleInstalled({
  //       module: sessionsModule,
  //     });

  //     if (!isModuleInstalled) {
  //       setLoading(false);
  //       // Install module if not already installed
  //       const hash = await nexusClient.installModule({
  //         module: sessionsModule,
  //       });

  //       const receipt = await nexusClient.waitForUserOperationReceipt({
  //         hash,
  //       });
  //       if (receipt.success.toString() !== "true") {
  //         setLoading(false);
  //         throw new Error(`Failed to install module`);
  //       }
  //     }
  //     const nexusSessionClient = nexusClient.extend(smartSessionActions());
  //     console.log("nexusSessionClient: ", nexusSessionClient);
  //     const createSessionsResponse = await nexusSessionClient.grantPermission({
  //       redeemer: sessionSigner.address,
  //       actions: [
  //         {
  //           actionTarget: USDT_CONTRACT_ADDRESS, // Target contract address
  //           actionTargetSelector: approveSelector, // Function selector (e.g., increment())
  //           actionPolicies: [getSudoPolicy()], // getSpendingLimitsPolicy, getUsageLimitPolicy, getValueLimitPolicy
  //         },
  //         {
  //           actionTarget: CRASH_GAME_CONTRACT, // Target contract address
  //           actionTargetSelector: addLiqudity,
  //           actionPolicies: [getSudoPolicy()],
  //         },
  //         {
  //           actionTarget: CRASH_GAME_CONTRACT, // Target contract address
  //           actionTargetSelector: cashoutSeclector, // Function selector (e.g., increment())
  //           actionPolicies: [getSudoPolicy()], // getSpendingLimitsPolicy, getUsageLimitPolicy, getValueLimitPolicy
  //         },
  //         {
  //           actionTarget: CRASH_GAME_CONTRACT, // Target contract address
  //           actionTargetSelector: placeBetSelector, // Function selector (e.g., increment())
  //           actionPolicies: [getSudoPolicy()], // getSpendingLimitsPolicy, getUsageLimitPolicy, getValueLimitPolicy
  //         },
  //         {
  //           actionTarget: LUCKIFY_CONTRACT_ADDRESS, // Target contract address
  //           actionTargetSelector: placeBetSelector, // Function selector (e.g., increment())
  //           actionPolicies: [getSudoPolicy()], // getSpendingLimitsPolicy, getUsageLimitPolicy, getValueLimitPolicy
  //         },
  //         {
  //           actionTarget: CRASH_GAME_CONTRACT, // Target contract address
  //           actionTargetSelector: withDraw,
  //           actionPolicies: [getSudoPolicy()],
  //         },
  //         // {
  //         //   to: CRASH_GAME_CONTRACT, // The target contract address
  //         //   data: encodeFunctionData({
  //         //     abi: CrashGameABI,
  //         //     functionName: "cashout",
  //         //     args: [], // Pass the contract parameters
  //         //   }),
  //         // },
  //       ],
  //     });

  //     const serialized = JSON.stringify(
  //       createSessionsResponse,
  //       (_, value) => (typeof value === "bigint" ? `${value}n` : value) // add 'n' to mark BigInt
  //     );

  //     setLoading(false);
  //     localStorage?.setItem("signForAll", serialized);
  //     localStorage?.setItem("privateKey", privateKey);
  //     localStorage?.setItem("nexusAccount", JSON.stringify(nexusAccount));
  //     localStorage?.setItem("placeBet", false);
  //     window.location.reload();
  //     // console.log("createSessionsResponse", createSessionsResponse);
  //     // const emulatedAccount = await toNexusAccount({
  //     //   accountAddress: nexusAccount.address, // The address that granted the permission
  //     //   signer: sessionSigner,
  //     //   chain,
  //     //   transport: viemHttp(RPC_URL),
  //     // });
  //     // // console.log("emulatedAccount: ", emulatedAccount);

  //     // const emulatedClient = createBicoBundlerClient({
  //     //   chain,
  //     //   account: emulatedAccount,
  //     //   transport: viemHttp(
  //     //     "https://bundler.biconomy.io/api/v3/56/bundler_3ZNf6pKi6WMQ8ScfAeWMfSxM"
  //     //   ),
  //     // });
  //     // console.log("emulatedClient: ", emulatedClient);

  //     // const smartSessionsClient = emulatedClient.extend(smartSessionActions());
  //     // try {
  //     //   const userOpHash = await smartSessionsClient.usePermission({
  //     //     sessionDetails: createSessionsResponse,
  //     //     calls: [
  //     //       {
  //     //         to: USDT_CONTRACT_ADDRESS, // Target contract address
  //     //         data: encodeFunctionData({
  //     //           abi: BalanceOfAbi,
  //     //           functionName: "approve",
  //     //           args: [CRASH_GAME_CONTRACT, 1000000000000000000000000n], // Approve a large amount for the create pool contract
  //     //         }),
  //     //       },
  //     //     ],
  //     //     mode: "ENABLE_AND_USE",
  //     //   });
  //     //   const receipt = await emulatedClient.waitForUserOperationReceipt({
  //     //     hash: userOpHash,
  //     //   });
  //     //   if (!receipt.success) {
  //     //     throw new Error("Smart sessions module validation failed");
  //     //   }

  //     //   console.log("Permission used successfully:", receipt);
  //     // } catch (error) {
  //     //   console.error("Error using permission:", error);
  //     // }
  //   } catch (err) {
  //     setLoading(false);
  //   }
  // };
  // tryCreatePoolTx();

  const getAlchemySmartAccount = async () => {
    try {
      // const privateKey = generatePrivateKey();
      // const signer = LocalAccountSigner.privateKeyToAccountSigner(privateKey);
      // localStorage?.setItem("privateKey", privateKey);
      // //getting client here
      // const client = createSmartWalletClient({
      //   transport: alchemy({ apiKey: "P3ClgXLHUva_tGn3ZET1v" }),
      //   chain: chain,
      //   signer,
      // });
      //getting smart account from client here
      // const smartAccountAddress = await client.requestAccount();
      // setSmartAccount(smartAccountAddress.address);
      // setSmartAccountClient(client);
    } catch (error) {
      console.log("error: ", error);
    }
  };
  // const dpDataHandler = async () => {
  //       const privKey = getIndexKey("sessionKeyData")
  //   setLocalDbData(privKey?.privatekey);

  // };
  const handleNavigate = () => {
    history.push("/myprofile");
  };
  return (
    <>
      <DepositModel
        show5={show5}
        setShow5={setShow5}
        handleClose5={handleClose5}
        internalAccount={internalAccount}
        userBalanceExternal={userBalanceExternal}
        ethExternalBalance={ethExternalBalance}
      />
      <WalletConnectModel
        route={route}
        showWallet={showWallet}
        internalAccountHandler={() => internalAccountHandler()}
        theme={theme}
        show={show}
        handleClose={handleClose}
      />
      {loading && <Loader text={loaderText} />}
      <section className="main-navbar">
        <Navbar expand="lg">
          {theme === "light" ? (
            <img
              src="/assets/menulight.svg"
              onClick={onToggleSidebar}
              alt="menu"
              className="menutoggle"
            />
          ) : (
            <img
              src="/assets/menu.svg"
              onClick={onToggleSidebar}
              alt="menu"
              className="menutoggle"
            />
          )}
          <Navbar.Brand onClick={() => history.push("/")}>
            {theme === "light" ? (
              <img src="/lightlogo.svg" alt="logo" className="nav-logo" />
            ) : (
              <img src="/logo.svg" alt="logo" className="nav-logo" />
            )}
          </Navbar.Brand>
          {/* <div className="mobilebtns">
            <button onClick={toggleMute} className="mutebtn d-none">
              {isMuted ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M13.5 10.6876V7.31257C13.5 7.16338 13.5593 7.02031 13.6648 6.91482C13.7702 6.80933 13.9133 6.75007 14.0625 6.75007C14.2117 6.75007 14.3548 6.80933 14.4602 6.91482C14.5657 7.02031 14.625 7.16338 14.625 7.31257V10.6876C14.625 10.8368 14.5657 10.9798 14.4602 11.0853C14.3548 11.1908 14.2117 11.2501 14.0625 11.2501C13.9133 11.2501 13.7702 11.1908 13.6648 11.0853C13.5593 10.9798 13.5 10.8368 13.5 10.6876ZM16.3125 5.62507C16.1633 5.62507 16.0202 5.68433 15.9148 5.78982C15.8093 5.89531 15.75 6.03838 15.75 6.18757V11.8126C15.75 11.9618 15.8093 12.1048 15.9148 12.2103C16.0202 12.3158 16.1633 12.3751 16.3125 12.3751C16.4617 12.3751 16.6048 12.3158 16.7102 12.2103C16.8157 12.1048 16.875 11.9618 16.875 11.8126V6.18757C16.875 6.03838 16.8157 5.89531 16.7102 5.78982C16.6048 5.68433 16.4617 5.62507 16.3125 5.62507ZM15.6038 14.8093C15.6545 14.8638 15.6939 14.9278 15.7197 14.9976C15.7455 15.0674 15.7572 15.1417 15.754 15.216C15.7509 15.2904 15.7331 15.3634 15.7016 15.4309C15.67 15.4983 15.6254 15.5588 15.5703 15.6088C15.5153 15.6589 15.4508 15.6975 15.3807 15.7225C15.3105 15.7475 15.2361 15.7582 15.1618 15.7542C15.0875 15.7502 15.0147 15.7315 14.9477 15.6992C14.8806 15.6669 14.8206 15.6215 14.7712 15.5658L11.8125 12.3111V15.7501C11.8124 15.8553 11.7828 15.9584 11.727 16.0477C11.6713 16.137 11.5916 16.2088 11.497 16.255C11.4024 16.3012 11.2968 16.32 11.1921 16.3092C11.0874 16.2983 10.9879 16.2583 10.9048 16.1937L5.99414 12.3751H2.8125C2.51413 12.3751 2.22798 12.2565 2.017 12.0456C1.80603 11.8346 1.6875 11.5484 1.6875 11.2501V6.75007C1.6875 6.4517 1.80603 6.16555 2.017 5.95457C2.22798 5.74359 2.51413 5.62507 2.8125 5.62507H5.73398L3.52125 3.19085C3.42302 3.08012 3.3724 2.93514 3.38035 2.78734C3.3883 2.63954 3.45419 2.50083 3.56373 2.40128C3.67327 2.30173 3.81763 2.24937 3.96552 2.25555C4.1134 2.26173 4.2529 2.32595 4.35375 2.43429L15.6038 14.8093ZM10.6875 11.0736L6.75703 6.75007H2.8125V11.2501H6.1875C6.31264 11.2499 6.43423 11.2917 6.53273 11.3689L10.6875 14.5998V11.0736ZM8.79328 4.87343L10.6875 3.39686V7.50804C10.6875 7.65722 10.7468 7.80029 10.8523 7.90578C10.9577 8.01127 11.1008 8.07054 11.25 8.07054C11.3992 8.07054 11.5423 8.01127 11.6477 7.90578C11.7532 7.80029 11.8125 7.65722 11.8125 7.50804V2.25007C11.8124 2.14481 11.7828 2.04169 11.727 1.95243C11.6713 1.86317 11.5916 1.79134 11.497 1.74512C11.4024 1.6989 11.2968 1.68014 11.1921 1.69097C11.0874 1.70181 10.9879 1.7418 10.9048 1.80639L8.10281 3.98608C7.98741 4.07844 7.913 4.21252 7.89567 4.35931C7.87835 4.50611 7.9195 4.65382 8.01023 4.77052C8.10096 4.88721 8.23397 4.9635 8.38051 4.98289C8.52704 5.00228 8.67532 4.96321 8.79328 4.87413V4.87343Z"
                    fill="#F24CA2"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M11.4968 1.74445C11.4022 1.69836 11.2966 1.67972 11.1919 1.69066C11.0873 1.7016 10.9878 1.74167 10.9048 1.80633L5.99414 5.625H2.8125C2.51413 5.625 2.22798 5.74353 2.017 5.9545C1.80603 6.16548 1.6875 6.45163 1.6875 6.75V11.25C1.6875 11.5484 1.80603 11.8345 2.017 12.0455C2.22798 12.2565 2.51413 12.375 2.8125 12.375H5.99414L10.9048 16.1937C10.9879 16.2583 11.0874 16.2983 11.1921 16.3091C11.2968 16.3199 11.4024 16.3012 11.497 16.2549C11.5916 16.2087 11.6713 16.1369 11.727 16.0476C11.7828 15.9584 11.8124 15.8553 11.8125 15.75V2.25C11.8125 2.14462 11.7829 2.04136 11.7271 1.95198C11.6713 1.86259 11.5915 1.79069 11.4968 1.74445ZM10.6875 14.5997L6.53273 11.3688C6.43423 11.2916 6.31264 11.2498 6.1875 11.25H2.8125V6.75H6.1875C6.31264 6.7502 6.43423 6.70835 6.53273 6.63117L10.6875 3.40031V14.5997ZM14.625 7.3125V10.6875C14.625 10.8367 14.5657 10.9798 14.4602 11.0852C14.3548 11.1907 14.2117 11.25 14.0625 11.25C13.9133 11.25 13.7702 11.1907 13.6648 11.0852C13.5593 10.9798 13.5 10.8367 13.5 10.6875V7.3125C13.5 7.16332 13.5593 7.02024 13.6648 6.91475C13.7702 6.80926 13.9133 6.75 14.0625 6.75C14.2117 6.75 14.3548 6.80926 14.4602 6.91475C14.5657 7.02024 14.625 7.16332 14.625 7.3125ZM16.875 6.1875V11.8125C16.875 11.9617 16.8157 12.1048 16.7102 12.2102C16.6048 12.3157 16.4617 12.375 16.3125 12.375C16.1633 12.375 16.0202 12.3157 15.9148 12.2102C15.8093 12.1048 15.75 11.9617 15.75 11.8125V6.1875C15.75 6.03832 15.8093 5.89524 15.9148 5.78975C16.0202 5.68426 16.1633 5.625 16.3125 5.625C16.4617 5.625 16.6048 5.68426 16.7102 5.78975C16.8157 5.89524 16.875 6.03832 16.875 6.1875Z"
                    fill="#F24CA2"
                  />
                </svg>
              )}
            </button>
            <div className="navbar-toggler">
              <span
                // onClick={handleShow1}
                onClick={handleShow2}
                className="navbar-toggler-icon"
              ></span>
            </div>
          </div> */}
          <div className="mobilebtns">
                  {smartAccount && account && (
              <button
                onClick={handleShow5}
                className="bluebtnmbl d-none"
              >
                Deposit
              </button>
            )}
            {account ? (
              <button className="profilebtn d-none">
                <div className="mainuser">
                  <div className="mainuserimg">
                    <img
                      src={
                        profile.profilePic
                          ? profile.profilePic.replace(
                              "https://media-luckify.s3.us-west-2.amazonaws.com",
                              "https://d1o0gghweg2hi9.cloudfront.net"
                            )
                          : "image-unavailable.png"
                      }
                      alt="img"
                      className="userinnerimg"
                    />
                  </div>
                  <p className="para">{profile.name}</p>
                </div>
              </button>
            ) : (
              <button onClick={handleShow} className="connectbtnmbl d-none">
                Connect Wallet
              </button>
            )}
          </div>
          <Navbar.Collapse id="navbarScroll">
            {/* <Nav>
                <Nav.Link
                  href="/"
                  className={currentPath === "/" ? "active" : ""}
                >
                  Play
                </Nav.Link>
                <Nav.Link
                  href="/liquidity"
                  className={currentPath === "/liquidity" ? "active" : ""}
                >
                  Liquidity
                </Nav.Link>
              </Nav> */}
            <div className="navbtns">
              <div className="toggle-container">
                <input
                  type="checkbox"
                  id="theme-toggle"
                  className="theme-toggle"
                  checked={theme === "dark"}
                  onChange={toggleTheme}
                />
                <label htmlFor="theme-toggle" className="toggle-label">
                  <span className="moon">
                    {theme === "light" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <mask id="path-1-inside-1_187_661" fill="white">
                          <path d="M4.75898 0.744141C4.72288 0.830004 4.68842 0.91724 4.65644 1.00586C3.65231 3.78817 5.09396 6.85797 7.87616 7.8623C8.96968 8.25698 10.1072 8.27132 11.1467 7.97754C10.0496 10.588 7.0868 11.9089 4.39276 10.9365C1.61043 9.93224 0.168847 6.86246 1.17304 4.08008C1.78258 2.39122 3.15366 1.19792 4.75898 0.744141Z" />
                        </mask>
                        <path
                          d="M4.75898 0.744141L6.00752 1.26906L7.09791 -1.32449L4.39056 -0.559194L4.75898 0.744141ZM4.65644 1.00586L3.38247 0.546061L3.38246 0.546085L4.65644 1.00586ZM7.87616 7.8623L7.41629 9.13625L7.41636 9.13627L7.87616 7.8623ZM11.1467 7.97754L12.3953 8.5023L13.4851 5.90916L10.7783 6.67419L11.1467 7.97754ZM4.39276 10.9365L3.93293 12.2105L3.93297 12.2105L4.39276 10.9365ZM1.17304 4.08008L-0.100932 3.62028L-0.100935 3.62029L1.17304 4.08008ZM4.75898 0.744141L3.51043 0.219224C3.46669 0.323251 3.4235 0.432375 3.38247 0.546061L4.65644 1.00586L5.93041 1.46566C5.95334 1.4021 5.97906 1.33676 6.00752 1.26906L4.75898 0.744141ZM4.65644 1.00586L3.38246 0.546085C2.1244 4.03201 3.93061 7.87796 7.41629 9.13625L7.87616 7.8623L8.33604 6.58836C6.25731 5.83797 5.18022 3.54432 5.93041 1.46563L4.65644 1.00586ZM7.87616 7.8623L7.41636 9.13627C8.78682 9.6309 10.2144 9.64848 11.515 9.28089L11.1467 7.97754L10.7783 6.67419C10 6.89416 9.15254 6.88305 8.33596 6.58834L7.87616 7.8623ZM11.1467 7.97754L9.89805 7.45278C9.07871 9.40233 6.86472 10.3888 4.85256 9.66255L4.39276 10.9365L3.93297 12.2105C7.30889 13.4289 11.0204 11.7737 12.3953 8.5023L11.1467 7.97754ZM4.39276 10.9365L4.8526 9.66257C2.77381 8.91223 1.69676 6.61865 2.44701 4.53987L1.17304 4.08008L-0.100935 3.62029C-1.35906 7.10627 0.447046 10.9523 3.93293 12.2105L4.39276 10.9365ZM1.17304 4.08008L2.44701 4.53988C2.90174 3.27993 3.92328 2.38785 5.12739 2.04748L4.75898 0.744141L4.39056 -0.559194C2.38404 0.00799453 0.663408 1.50251 -0.100932 3.62028L1.17304 4.08008Z"
                          fill="#F6F6F7"
                          mask="url(#path-1-inside-1_187_661)"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <mask id="path-1-inside-1_190_41" fill="white">
                          <path d="M4.75894 0.744049C4.72287 0.829842 4.68933 0.917224 4.65737 1.00577C3.65314 3.78821 5.09466 6.85798 7.8771 7.86221C8.97044 8.25673 10.1074 8.27114 11.1466 7.97745C10.0495 10.5879 7.08674 11.9088 4.39273 10.9364C1.61052 9.9321 0.168871 6.8623 1.173 4.07999C1.78252 2.39119 3.15369 1.19787 4.75894 0.744049Z" />
                        </mask>
                        <path
                          d="M4.75894 0.744049L6.00749 1.26895L7.09787 -1.32468L4.39048 -0.559273L4.75894 0.744049ZM4.65737 1.00577L3.38342 0.545931L3.3834 0.545969L4.65737 1.00577ZM7.8771 7.86221L7.4173 9.13618L7.4174 9.13622L7.8771 7.86221ZM11.1466 7.97745L12.3952 8.50222L13.4851 5.90917L10.7783 6.67409L11.1466 7.97745ZM4.39273 10.9364L3.93285 12.2104L3.93293 12.2104L4.39273 10.9364ZM1.173 4.07999L-0.100971 3.62019L-0.100979 3.62021L1.173 4.07999ZM4.75894 0.744049L3.51038 0.219149C3.46334 0.331036 3.42137 0.440779 3.38342 0.545931L4.65737 1.00577L5.93133 1.4656C5.9573 1.39367 5.9824 1.32865 6.00749 1.26895L4.75894 0.744049ZM4.65737 1.00577L3.3834 0.545969C2.12524 4.03199 3.93125 7.878 7.4173 9.13618L7.8771 7.86221L8.3369 6.58824C6.25806 5.83795 5.18105 3.54443 5.93134 1.46557L4.65737 1.00577ZM7.8771 7.86221L7.4174 9.13622C8.78755 9.63062 10.2145 9.64832 11.515 9.28081L11.1466 7.97745L10.7783 6.67409C10.0002 6.89397 9.15333 6.88284 8.3368 6.58821L7.8771 7.86221ZM11.1466 7.97745L9.89802 7.45267C9.07866 9.40221 6.86465 10.3887 4.85252 9.66246L4.39273 10.9364L3.93293 12.2104C7.30884 13.4288 11.0204 11.7735 12.3952 8.50222L11.1466 7.97745ZM4.39273 10.9364L4.8526 9.66249C2.77387 8.9121 1.69678 6.61846 2.44698 4.53976L1.173 4.07999L-0.100979 3.62021C-1.35904 7.10614 0.44716 10.9521 3.93285 12.2104L4.39273 10.9364ZM1.173 4.07999L2.44697 4.53979C2.90167 3.27993 3.92329 2.38778 5.1274 2.04737L4.75894 0.744049L4.39048 -0.559273C2.3841 0.00794774 0.663358 1.50245 -0.100971 3.62019L1.173 4.07999Z"
                          fill="#13151A"
                          mask="url(#path-1-inside-1_190_41)"
                        />
                      </svg>
                    )}
                  </span>
                  <span className="sun">
                    {theme === "light" ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <circle
                          cx="5.91193"
                          cy="6.01886"
                          r="2.06791"
                          stroke="#13151A"
                          stroke-width="1.43218"
                        />
                        <path
                          d="M6.82129 10.1362L6.84222 11.817L5.17835 11.8377L5.15742 10.157L6.82129 10.1362Z"
                          fill="#13151A"
                        />
                        <path
                          d="M6.82129 0.162598L6.84222 1.84332L5.17835 1.86405L5.15742 0.183323L6.82129 0.162598Z"
                          fill="#13151A"
                        />
                        <path
                          d="M1.86377 6.82129L0.183045 6.84222L0.16232 5.17835L1.84304 5.15742L1.86377 6.82129Z"
                          fill="#13151A"
                        />
                        <path
                          d="M11.8374 6.82129L10.1567 6.84222L10.136 5.17835L11.8167 5.15742L11.8374 6.82129Z"
                          fill="#13151A"
                        />
                        <path
                          d="M2.49463 3.65674L1.29137 2.48309L2.45325 1.2919L3.65651 2.46555L2.49463 3.65674Z"
                          fill="#13151A"
                        />
                        <path
                          d="M9.54639 10.7085L8.34313 9.53485L9.50501 8.34366L10.7083 9.51731L9.54639 10.7085Z"
                          fill="#13151A"
                        />
                        <path
                          d="M8.34326 2.49463L9.51691 1.29137L10.7081 2.45325L9.53445 3.65651L8.34326 2.49463Z"
                          fill="#13151A"
                        />
                        <path
                          d="M1.29199 9.54688L2.46564 8.34362L3.65683 9.5055L2.48318 10.7088L1.29199 9.54688Z"
                          fill="#13151A"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <circle
                          cx="5.91193"
                          cy="6.0186"
                          r="2.06791"
                          stroke="#F6F6F7"
                          stroke-width="1.43218"
                        />
                        <path
                          d="M6.82129 10.136L6.84222 11.8167L5.17835 11.8374L5.15742 10.1567L6.82129 10.136Z"
                          fill="#F6F6F7"
                        />
                        <path
                          d="M6.82129 0.162567L6.84222 1.84329L5.17835 1.86402L5.15742 0.183292L6.82129 0.162567Z"
                          fill="#F6F6F7"
                        />
                        <path
                          d="M1.86377 6.82135L0.183045 6.84228L0.16232 5.17841L1.84304 5.15748L1.86377 6.82135Z"
                          fill="#F6F6F7"
                        />
                        <path
                          d="M11.8374 6.82135L10.1567 6.84228L10.136 5.17841L11.8167 5.15748L11.8374 6.82135Z"
                          fill="#F6F6F7"
                        />
                        <path
                          d="M2.49463 3.65648L1.29137 2.48283L2.45325 1.29164L3.65651 2.46529L2.49463 3.65648Z"
                          fill="#F6F6F7"
                        />
                        <path
                          d="M9.54639 10.7083L8.34313 9.53466L9.50501 8.34348L10.7083 9.51712L9.54639 10.7083Z"
                          fill="#F6F6F7"
                        />
                        <path
                          d="M8.34326 2.49455L9.51691 1.2913L10.7081 2.45318L9.53445 3.65643L8.34326 2.49455Z"
                          fill="#F6F6F7"
                        />
                        <path
                          d="M1.29199 9.54663L2.46564 8.34338L3.65683 9.50526L2.48318 10.7085L1.29199 9.54663Z"
                          fill="#F6F6F7"
                        />
                      </svg>
                    )}
                  </span>
                  <span className="toggle-slider"></span>
                </label>
              </div>
              <button onClick={toggleMute} className="mutebtn">
                {isMuted ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M13.5 10.6876V7.31257C13.5 7.16338 13.5593 7.02031 13.6648 6.91482C13.7702 6.80933 13.9133 6.75007 14.0625 6.75007C14.2117 6.75007 14.3548 6.80933 14.4602 6.91482C14.5657 7.02031 14.625 7.16338 14.625 7.31257V10.6876C14.625 10.8368 14.5657 10.9798 14.4602 11.0853C14.3548 11.1908 14.2117 11.2501 14.0625 11.2501C13.9133 11.2501 13.7702 11.1908 13.6648 11.0853C13.5593 10.9798 13.5 10.8368 13.5 10.6876ZM16.3125 5.62507C16.1633 5.62507 16.0202 5.68433 15.9148 5.78982C15.8093 5.89531 15.75 6.03838 15.75 6.18757V11.8126C15.75 11.9618 15.8093 12.1048 15.9148 12.2103C16.0202 12.3158 16.1633 12.3751 16.3125 12.3751C16.4617 12.3751 16.6048 12.3158 16.7102 12.2103C16.8157 12.1048 16.875 11.9618 16.875 11.8126V6.18757C16.875 6.03838 16.8157 5.89531 16.7102 5.78982C16.6048 5.68433 16.4617 5.62507 16.3125 5.62507ZM15.6038 14.8093C15.6545 14.8638 15.6939 14.9278 15.7197 14.9976C15.7455 15.0674 15.7572 15.1417 15.754 15.216C15.7509 15.2904 15.7331 15.3634 15.7016 15.4309C15.67 15.4983 15.6254 15.5588 15.5703 15.6088C15.5153 15.6589 15.4508 15.6975 15.3807 15.7225C15.3105 15.7475 15.2361 15.7582 15.1618 15.7542C15.0875 15.7502 15.0147 15.7315 14.9477 15.6992C14.8806 15.6669 14.8206 15.6215 14.7712 15.5658L11.8125 12.3111V15.7501C11.8124 15.8553 11.7828 15.9584 11.727 16.0477C11.6713 16.137 11.5916 16.2088 11.497 16.255C11.4024 16.3012 11.2968 16.32 11.1921 16.3092C11.0874 16.2983 10.9879 16.2583 10.9048 16.1937L5.99414 12.3751H2.8125C2.51413 12.3751 2.22798 12.2565 2.017 12.0456C1.80603 11.8346 1.6875 11.5484 1.6875 11.2501V6.75007C1.6875 6.4517 1.80603 6.16555 2.017 5.95457C2.22798 5.74359 2.51413 5.62507 2.8125 5.62507H5.73398L3.52125 3.19085C3.42302 3.08012 3.3724 2.93514 3.38035 2.78734C3.3883 2.63954 3.45419 2.50083 3.56373 2.40128C3.67327 2.30173 3.81763 2.24937 3.96552 2.25555C4.1134 2.26173 4.2529 2.32595 4.35375 2.43429L15.6038 14.8093ZM10.6875 11.0736L6.75703 6.75007H2.8125V11.2501H6.1875C6.31264 11.2499 6.43423 11.2917 6.53273 11.3689L10.6875 14.5998V11.0736ZM8.79328 4.87343L10.6875 3.39686V7.50804C10.6875 7.65722 10.7468 7.80029 10.8523 7.90578C10.9577 8.01127 11.1008 8.07054 11.25 8.07054C11.3992 8.07054 11.5423 8.01127 11.6477 7.90578C11.7532 7.80029 11.8125 7.65722 11.8125 7.50804V2.25007C11.8124 2.14481 11.7828 2.04169 11.727 1.95243C11.6713 1.86317 11.5916 1.79134 11.497 1.74512C11.4024 1.6989 11.2968 1.68014 11.1921 1.69097C11.0874 1.70181 10.9879 1.7418 10.9048 1.80639L8.10281 3.98608C7.98741 4.07844 7.913 4.21252 7.89567 4.35931C7.87835 4.50611 7.9195 4.65382 8.01023 4.77052C8.10096 4.88721 8.23397 4.9635 8.38051 4.98289C8.52704 5.00228 8.67532 4.96321 8.79328 4.87413V4.87343Z"
                      fill="#F24CA2"
                    />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M11.4968 1.74445C11.4022 1.69836 11.2966 1.67972 11.1919 1.69066C11.0873 1.7016 10.9878 1.74167 10.9048 1.80633L5.99414 5.625H2.8125C2.51413 5.625 2.22798 5.74353 2.017 5.9545C1.80603 6.16548 1.6875 6.45163 1.6875 6.75V11.25C1.6875 11.5484 1.80603 11.8345 2.017 12.0455C2.22798 12.2565 2.51413 12.375 2.8125 12.375H5.99414L10.9048 16.1937C10.9879 16.2583 11.0874 16.2983 11.1921 16.3091C11.2968 16.3199 11.4024 16.3012 11.497 16.2549C11.5916 16.2087 11.6713 16.1369 11.727 16.0476C11.7828 15.9584 11.8124 15.8553 11.8125 15.75V2.25C11.8125 2.14462 11.7829 2.04136 11.7271 1.95198C11.6713 1.86259 11.5915 1.79069 11.4968 1.74445ZM10.6875 14.5997L6.53273 11.3688C6.43423 11.2916 6.31264 11.2498 6.1875 11.25H2.8125V6.75H6.1875C6.31264 6.7502 6.43423 6.70835 6.53273 6.63117L10.6875 3.40031V14.5997ZM14.625 7.3125V10.6875C14.625 10.8367 14.5657 10.9798 14.4602 11.0852C14.3548 11.1907 14.2117 11.25 14.0625 11.25C13.9133 11.25 13.7702 11.1907 13.6648 11.0852C13.5593 10.9798 13.5 10.8367 13.5 10.6875V7.3125C13.5 7.16332 13.5593 7.02024 13.6648 6.91475C13.7702 6.80926 13.9133 6.75 14.0625 6.75C14.2117 6.75 14.3548 6.80926 14.4602 6.91475C14.5657 7.02024 14.625 7.16332 14.625 7.3125ZM16.875 6.1875V11.8125C16.875 11.9617 16.8157 12.1048 16.7102 12.2102C16.6048 12.3157 16.4617 12.375 16.3125 12.375C16.1633 12.375 16.0202 12.3157 15.9148 12.2102C15.8093 12.1048 15.75 11.9617 15.75 11.8125V6.1875C15.75 6.03832 15.8093 5.89524 15.9148 5.78975C16.0202 5.68426 16.1633 5.625 16.3125 5.625C16.4617 5.625 16.6048 5.68426 16.7102 5.78975C16.8157 5.89524 16.875 6.03832 16.875 6.1875Z"
                      fill="#F24CA2"
                    />
                  </svg>
                )}
              </button>
              {smartAccount && account && (
                <button onClick={handleShow5} className="bluebtn">
                  Deposit
                </button>
              )}
              {account ? (
                <button className="disconnectbtn" onClick={disconnectWallet}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M10 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10"
                      stroke="#FF3434"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M5.33594 11.3337L2.0026 8.00033L5.33594 4.66699"
                      stroke="#FF3434"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2 8H10"
                      stroke="#FF3434"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Disconnect
                </button>
              ) : (
                <button onClick={handleShow} className="connectbtn">
                  Connect Wallet
                </button>
              )}
              {smartAccount && account && (
                <div className="maindrop">
                  <Dropdown align="end">
                    <Dropdown.Toggle id="dropdown-basic">
                      <div className="mainuser">
                        <div className="mainuserimg">
                          <img
                            src={
                              profile.profilePic
                                ? profile.profilePic.replace(
                                    "https://media-luckify.s3.us-west-2.amazonaws.com",
                                    "https://d1o0gghweg2hi9.cloudfront.net"
                                  )
                                : "image-unavailable.png"
                            }
                            alt="img"
                            className="userinnerimg"
                          />
                        </div>
                        <p className="para">{profile.name}</p>
                      </div>

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M5 7.5L10 12.5L15 7.5"
                          stroke="white"
                          stroke-width="1.04"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item onClick={handleNavigate}>
                        <div className="balancemain">
                          <div>
                            <h6 className="upperhead">Wallet & Profile</h6>
                            <p className="balancetext">
                              $
                              {Number(totalBalance).toLocaleString(undefined, {
                                minimumFractionDigits: 4,
                                maximumFractionDigits: 4,
                              })}
                            </p>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M13.1722 12.0002L8.22217 7.05021L9.63617 5.63721L16.0002 12.0002L9.63617 18.3642L8.22217 16.9492L13.1722 12.0002Z"
                              fill={theme === "light" ? "#13151A" : "white"}
                            />
                          </svg>
                        </div>
                      </Dropdown.Item>
                      {/* <Dropdown.Item onClick={disconnectWallet}>
                        <p className="red">Disconnect</p>
                      </Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
          </Navbar.Collapse>
        </Navbar>
      </section>

      <Offcanvas show={show1} onHide={handleClose1} className="sidebar">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {theme === "light" ? (
              <Nav.Link
                href="/"
                className={currentPath === "/" ? "active" : ""}
              >
                <img src="/lightlogo.svg" alt="logo" className="nav-logo" />
              </Nav.Link>
            ) : (
              <Nav.Link
                href="/"
                className={currentPath === "/" ? "active" : ""}
              >
                <img src="/logo.svg" alt="logo" className="nav-logo" />
              </Nav.Link>
            )}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Nav.Link href="/" className={currentPath === "/" ? "active" : ""}>
            Play
          </Nav.Link>
          <Nav.Link
            href="/liquidity"
            className={currentPath === "/liquidity" ? "active" : ""}
          >
            Liquidity
          </Nav.Link>
          <div className="nav-link">
            theme
            <div className="toggle-container">
              <input
                type="checkbox"
                id="theme-toggle"
                className="theme-toggle"
                checked={theme === "dark"}
                onChange={toggleTheme}
              />
              <label htmlFor="theme-toggle" className="toggle-label">
                <span className="moon">
                  {theme === "light" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <mask id="path-1-inside-1_187_661" fill="white">
                        <path d="M4.75898 0.744141C4.72288 0.830004 4.68842 0.91724 4.65644 1.00586C3.65231 3.78817 5.09396 6.85797 7.87616 7.8623C8.96968 8.25698 10.1072 8.27132 11.1467 7.97754C10.0496 10.588 7.0868 11.9089 4.39276 10.9365C1.61043 9.93224 0.168847 6.86246 1.17304 4.08008C1.78258 2.39122 3.15366 1.19792 4.75898 0.744141Z" />
                      </mask>
                      <path
                        d="M4.75898 0.744141L6.00752 1.26906L7.09791 -1.32449L4.39056 -0.559194L4.75898 0.744141ZM4.65644 1.00586L3.38247 0.546061L3.38246 0.546085L4.65644 1.00586ZM7.87616 7.8623L7.41629 9.13625L7.41636 9.13627L7.87616 7.8623ZM11.1467 7.97754L12.3953 8.5023L13.4851 5.90916L10.7783 6.67419L11.1467 7.97754ZM4.39276 10.9365L3.93293 12.2105L3.93297 12.2105L4.39276 10.9365ZM1.17304 4.08008L-0.100932 3.62028L-0.100935 3.62029L1.17304 4.08008ZM4.75898 0.744141L3.51043 0.219224C3.46669 0.323251 3.4235 0.432375 3.38247 0.546061L4.65644 1.00586L5.93041 1.46566C5.95334 1.4021 5.97906 1.33676 6.00752 1.26906L4.75898 0.744141ZM4.65644 1.00586L3.38246 0.546085C2.1244 4.03201 3.93061 7.87796 7.41629 9.13625L7.87616 7.8623L8.33604 6.58836C6.25731 5.83797 5.18022 3.54432 5.93041 1.46563L4.65644 1.00586ZM7.87616 7.8623L7.41636 9.13627C8.78682 9.6309 10.2144 9.64848 11.515 9.28089L11.1467 7.97754L10.7783 6.67419C10 6.89416 9.15254 6.88305 8.33596 6.58834L7.87616 7.8623ZM11.1467 7.97754L9.89805 7.45278C9.07871 9.40233 6.86472 10.3888 4.85256 9.66255L4.39276 10.9365L3.93297 12.2105C7.30889 13.4289 11.0204 11.7737 12.3953 8.5023L11.1467 7.97754ZM4.39276 10.9365L4.8526 9.66257C2.77381 8.91223 1.69676 6.61865 2.44701 4.53987L1.17304 4.08008L-0.100935 3.62029C-1.35906 7.10627 0.447046 10.9523 3.93293 12.2105L4.39276 10.9365ZM1.17304 4.08008L2.44701 4.53988C2.90174 3.27993 3.92328 2.38785 5.12739 2.04748L4.75898 0.744141L4.39056 -0.559194C2.38404 0.00799453 0.663408 1.50251 -0.100932 3.62028L1.17304 4.08008Z"
                        fill="#F6F6F7"
                        mask="url(#path-1-inside-1_187_661)"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <mask id="path-1-inside-1_190_41" fill="white">
                        <path d="M4.75894 0.744049C4.72287 0.829842 4.68933 0.917224 4.65737 1.00577C3.65314 3.78821 5.09466 6.85798 7.8771 7.86221C8.97044 8.25673 10.1074 8.27114 11.1466 7.97745C10.0495 10.5879 7.08674 11.9088 4.39273 10.9364C1.61052 9.9321 0.168871 6.8623 1.173 4.07999C1.78252 2.39119 3.15369 1.19787 4.75894 0.744049Z" />
                      </mask>
                      <path
                        d="M4.75894 0.744049L6.00749 1.26895L7.09787 -1.32468L4.39048 -0.559273L4.75894 0.744049ZM4.65737 1.00577L3.38342 0.545931L3.3834 0.545969L4.65737 1.00577ZM7.8771 7.86221L7.4173 9.13618L7.4174 9.13622L7.8771 7.86221ZM11.1466 7.97745L12.3952 8.50222L13.4851 5.90917L10.7783 6.67409L11.1466 7.97745ZM4.39273 10.9364L3.93285 12.2104L3.93293 12.2104L4.39273 10.9364ZM1.173 4.07999L-0.100971 3.62019L-0.100979 3.62021L1.173 4.07999ZM4.75894 0.744049L3.51038 0.219149C3.46334 0.331036 3.42137 0.440779 3.38342 0.545931L4.65737 1.00577L5.93133 1.4656C5.9573 1.39367 5.9824 1.32865 6.00749 1.26895L4.75894 0.744049ZM4.65737 1.00577L3.3834 0.545969C2.12524 4.03199 3.93125 7.878 7.4173 9.13618L7.8771 7.86221L8.3369 6.58824C6.25806 5.83795 5.18105 3.54443 5.93134 1.46557L4.65737 1.00577ZM7.8771 7.86221L7.4174 9.13622C8.78755 9.63062 10.2145 9.64832 11.515 9.28081L11.1466 7.97745L10.7783 6.67409C10.0002 6.89397 9.15333 6.88284 8.3368 6.58821L7.8771 7.86221ZM11.1466 7.97745L9.89802 7.45267C9.07866 9.40221 6.86465 10.3887 4.85252 9.66246L4.39273 10.9364L3.93293 12.2104C7.30884 13.4288 11.0204 11.7735 12.3952 8.50222L11.1466 7.97745ZM4.39273 10.9364L4.8526 9.66249C2.77387 8.9121 1.69678 6.61846 2.44698 4.53976L1.173 4.07999L-0.100979 3.62021C-1.35904 7.10614 0.44716 10.9521 3.93285 12.2104L4.39273 10.9364ZM1.173 4.07999L2.44697 4.53979C2.90167 3.27993 3.92329 2.38778 5.1274 2.04737L4.75894 0.744049L4.39048 -0.559273C2.3841 0.00794774 0.663358 1.50245 -0.100971 3.62019L1.173 4.07999Z"
                        fill="#13151A"
                        mask="url(#path-1-inside-1_190_41)"
                      />
                    </svg>
                  )}
                </span>
                <span className="sun">
                  {theme === "light" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <circle
                        cx="5.91193"
                        cy="6.01886"
                        r="2.06791"
                        stroke="#13151A"
                        stroke-width="1.43218"
                      />
                      <path
                        d="M6.82129 10.1362L6.84222 11.817L5.17835 11.8377L5.15742 10.157L6.82129 10.1362Z"
                        fill="#13151A"
                      />
                      <path
                        d="M6.82129 0.162598L6.84222 1.84332L5.17835 1.86405L5.15742 0.183323L6.82129 0.162598Z"
                        fill="#13151A"
                      />
                      <path
                        d="M1.86377 6.82129L0.183045 6.84222L0.16232 5.17835L1.84304 5.15742L1.86377 6.82129Z"
                        fill="#13151A"
                      />
                      <path
                        d="M11.8374 6.82129L10.1567 6.84222L10.136 5.17835L11.8167 5.15742L11.8374 6.82129Z"
                        fill="#13151A"
                      />
                      <path
                        d="M2.49463 3.65674L1.29137 2.48309L2.45325 1.2919L3.65651 2.46555L2.49463 3.65674Z"
                        fill="#13151A"
                      />
                      <path
                        d="M9.54639 10.7085L8.34313 9.53485L9.50501 8.34366L10.7083 9.51731L9.54639 10.7085Z"
                        fill="#13151A"
                      />
                      <path
                        d="M8.34326 2.49463L9.51691 1.29137L10.7081 2.45325L9.53445 3.65651L8.34326 2.49463Z"
                        fill="#13151A"
                      />
                      <path
                        d="M1.29199 9.54688L2.46564 8.34362L3.65683 9.5055L2.48318 10.7088L1.29199 9.54688Z"
                        fill="#13151A"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <circle
                        cx="5.91193"
                        cy="6.0186"
                        r="2.06791"
                        stroke="#F6F6F7"
                        stroke-width="1.43218"
                      />
                      <path
                        d="M6.82129 10.136L6.84222 11.8167L5.17835 11.8374L5.15742 10.1567L6.82129 10.136Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M6.82129 0.162567L6.84222 1.84329L5.17835 1.86402L5.15742 0.183292L6.82129 0.162567Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M1.86377 6.82135L0.183045 6.84228L0.16232 5.17841L1.84304 5.15748L1.86377 6.82135Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M11.8374 6.82135L10.1567 6.84228L10.136 5.17841L11.8167 5.15748L11.8374 6.82135Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M2.49463 3.65648L1.29137 2.48283L2.45325 1.29164L3.65651 2.46529L2.49463 3.65648Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M9.54639 10.7083L8.34313 9.53466L9.50501 8.34348L10.7083 9.51712L9.54639 10.7083Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M8.34326 2.49455L9.51691 1.2913L10.7081 2.45318L9.53445 3.65643L8.34326 2.49455Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M1.29199 9.54663L2.46564 8.34338L3.65683 9.50526L2.48318 10.7085L1.29199 9.54663Z"
                        fill="#F6F6F7"
                      />
                    </svg>
                  )}
                </span>
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>

          <div className="sidebarbtns">
            {account ? (
              <button className="disconnectbtn" onClick={disconnectWallet}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M10 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10"
                    stroke="#FF3434"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.33594 11.3337L2.0026 8.00033L5.33594 4.66699"
                    stroke="#FF3434"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 8H10"
                    stroke="#FF3434"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Disconnect
              </button>
            ) : (
              <button
                onClick={() => {
                  handleClose1();
                  handleShow();
                }}
                className="connectbtn"
              >
                Connect Wallet
              </button>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas show={show2} onHide={handleClose2} className="mainoffcan">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {theme === "light" ? (
              <a href="/">
                <img src="/lightlogo.svg" alt="logo" className="nav-logo" />
              </a>
            ) : (
              <a href="/">
                <img src="/logo.svg" alt="logo" className="nav-logo" />
              </a>
            )}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="maincontent">
            {smartAccount && account && (
              <>
                <h4 className="upperheading">Wallet & Profile</h4>
                <a href="/myprofile" onClick={handleClose2} className="mainbox">
                  <p className="mainpara">
                    $
                    {Number(totalBalance).toLocaleString(undefined, {
                      minimumFractionDigits: 4,
                      maximumFractionDigits: 4,
                    })}
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M13.1717 12.0002L8.22168 7.05021L9.63568 5.63721L15.9997 12.0002L9.63568 18.3642L8.22168 16.9492L13.1717 12.0002Z"
                      fill={theme === "light" ? "#13151A" : "white"}
                    />
                  </svg>
                </a>
              </>
            )}
            <h4 className="upperheading">Games</h4>
            <a
              href="/"
              className={
                currentPath === "/" ? "secondbox d-block" : " lastbox d-block"
              }
              onClick={handleClose2}
            >
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M12.5 17.5V10.8333C12.5 10.6123 12.4122 10.4004 12.2559 10.2441C12.0996 10.0878 11.8877 10 11.6667 10H8.33333C8.11232 10 7.90036 10.0878 7.74408 10.2441C7.5878 10.4004 7.5 10.6123 7.5 10.8333V17.5"
                    stroke="#606367"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.5 8.33333C2.49994 8.09088 2.55278 7.85134 2.65482 7.63142C2.75687 7.4115 2.90566 7.21649 3.09083 7.05999L8.92417 2.05999C9.22499 1.80575 9.60613 1.66626 10 1.66626C10.3939 1.66626 10.775 1.80575 11.0758 2.05999L16.9092 7.05999C17.0943 7.21649 17.2431 7.4115 17.3452 7.63142C17.4472 7.85134 17.5001 8.09088 17.5 8.33333V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V8.33333Z"
                    stroke="#606367"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                home
              </p>
            </a>
            <a
              href="/tothemoon"
              className={
                currentPath === "/tothemoon"
                  ? "secondbox d-block"
                  : " lastbox d-block"
              }
              onClick={handleClose2}
            >
              <p>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10 2.5C9.00544 3.49456 8.4467 4.84348 8.4467 6.25C8.4467 7.65652 9.00544 9.00544 10 10C10.9946 10.9946 12.3435 11.5533 13.75 11.5533C15.1565 11.5533 16.5054 10.9946 17.5 10C17.5 11.4834 17.0601 12.9334 16.236 14.1668C15.4119 15.4001 14.2406 16.3614 12.8701 16.9291C11.4997 17.4968 9.99168 17.6453 8.53683 17.3559C7.08197 17.0665 5.7456 16.3522 4.6967 15.3033C3.64781 14.2544 2.9335 12.918 2.64411 11.4632C2.35472 10.0083 2.50325 8.50032 3.07091 7.12987C3.63856 5.75943 4.59986 4.58809 5.83323 3.76398C7.0666 2.93987 8.51664 2.5 10 2.5Z"
                    stroke="#606367"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
         Crash
              </p>
            </a>
            <a
              href="/play"
              className={
                currentPath === "/play"
                  ? "secondbox d-block"
                  : " lastbox d-block"
              }
              onClick={handleClose2}
            >
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M6.6665 11.6665C9.42793 11.6665 11.6665 9.42793 11.6665 6.6665C11.6665 3.90508 9.42793 1.6665 6.6665 1.6665C3.90508 1.6665 1.6665 3.90508 1.6665 6.6665C1.6665 9.42793 3.90508 11.6665 6.6665 11.6665Z"
                    stroke="#F24CA2"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.075 8.6416C15.8628 8.93529 16.5638 9.42288 17.1132 10.0593C17.6625 10.6957 18.0426 11.4603 18.2182 12.2825C18.3937 13.1047 18.3591 13.9579 18.1176 14.7631C17.876 15.5684 17.4353 16.2998 16.8362 16.8896C16.2371 17.4794 15.499 17.9087 14.69 18.1376C13.8811 18.3666 13.0275 18.3879 12.2081 18.1995C11.3888 18.0111 10.6301 17.6192 10.0024 17.0599C9.37465 16.5007 8.89806 15.7922 8.6167 14.9999"
                    stroke="#F24CA2"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.8335 5H6.66683V8.33333"
                    stroke="#F24CA2"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M13.9249 11.5669L14.5082 12.1586L12.1582 14.5086"
                    stroke="#F24CA2"
                    stroke-width="1.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
         Dice
              </p>
            </a>
            <a
              href="/liquidity"
              className={
                currentPath === "/liquidity"
                  ? "secondbox d-block"
                  : " lastbox d-block"
              }
              onClick={handleClose2}
            >
              <p>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#606367"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 2C12 2 6 9 6 14a6 6 0 0012 0c0-5-6-12-6-12z" />
                  <path d="M12 10v4" />
                  <path d="M10 12h4" />
                </svg>
                Liquidity
              </p>
            </a>
          </div>
        </Offcanvas.Body>
        <div className="lastconet">
          <div className="nav-linkk">
            THEME
            <div className="toggle-container">
              <input
                type="checkbox"
                id="theme-toggle"
                className="theme-toggle"
                checked={theme === "dark"}
                onChange={toggleTheme}
              />
              <label htmlFor="theme-toggle" className="toggle-label">
                <span className="moon">
                  {theme === "light" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <mask id="path-1-inside-1_768_14917" fill="white">
                        <path d="M4.75894 0.742188C4.72287 0.82798 4.68933 0.915362 4.65737 1.00391C3.65314 3.78635 5.09466 6.85612 7.8771 7.86035C8.97044 8.25487 10.1074 8.26928 11.1466 7.97559C10.0495 10.586 7.08674 11.9069 4.39273 10.9346C1.61052 9.93023 0.168871 6.86044 1.173 4.07812C1.78252 2.38933 3.15369 1.196 4.75894 0.742188Z" />
                      </mask>
                      <path
                        d="M4.75894 0.742188L6.00749 1.26709L7.09787 -1.32654L4.39048 -0.561135L4.75894 0.742188ZM4.65737 1.00391L3.38342 0.54407L3.3834 0.544108L4.65737 1.00391ZM7.8771 7.86035L7.4173 9.13432L7.4174 9.13436L7.8771 7.86035ZM11.1466 7.97559L12.3952 8.50036L13.4851 5.9073L10.7783 6.67222L11.1466 7.97559ZM4.39273 10.9346L3.93285 12.2085L3.93293 12.2085L4.39273 10.9346ZM1.173 4.07812L-0.100971 3.61833L-0.100979 3.61835L1.173 4.07812ZM4.75894 0.742188L3.51038 0.217288C3.46334 0.329174 3.42137 0.438918 3.38342 0.54407L4.65737 1.00391L5.93133 1.46374C5.9573 1.39181 5.9824 1.32679 6.00749 1.26709L4.75894 0.742188ZM4.65737 1.00391L3.3834 0.544108C2.12524 4.03013 3.93125 7.87614 7.4173 9.13432L7.8771 7.86035L8.3369 6.58638C6.25806 5.83609 5.18105 3.54257 5.93134 1.46371L4.65737 1.00391ZM7.8771 7.86035L7.4174 9.13436C8.78755 9.62875 10.2145 9.64646 11.515 9.27895L11.1466 7.97559L10.7783 6.67222C10.0002 6.89211 9.15333 6.88098 8.3368 6.58635L7.8771 7.86035ZM11.1466 7.97559L9.89802 7.45081C9.07866 9.40035 6.86465 10.3868 4.85252 9.6606L4.39273 10.9346L3.93293 12.2085C7.30884 13.427 11.0204 11.7717 12.3952 8.50036L11.1466 7.97559ZM4.39273 10.9346L4.8526 9.66063C2.77387 8.91024 1.69678 6.6166 2.44698 4.5379L1.173 4.07812L-0.100979 3.61835C-1.35904 7.10428 0.44716 10.9502 3.93285 12.2085L4.39273 10.9346ZM1.173 4.07812L2.44697 4.53792C2.90167 3.27807 3.92329 2.38592 5.1274 2.04551L4.75894 0.742188L4.39048 -0.561135C2.3841 0.00608617 0.663358 1.50059 -0.100971 3.61833L1.173 4.07812Z"
                        fill="#F6F6F7"
                        mask="url(#path-1-inside-1_768_14917)"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <mask id="path-1-inside-1_765_6715" fill="white">
                        <path d="M4.75881 0.744141C4.72275 0.829933 4.68921 0.917315 4.65725 1.00586C3.65302 3.7883 5.09454 6.85807 7.87698 7.8623C8.97032 8.25682 10.1072 8.27123 11.1465 7.97754C10.0494 10.588 7.08662 11.9088 4.3926 10.9365C1.61039 9.93219 0.168748 6.86239 1.17288 4.08008C1.78239 2.39128 3.15357 1.19796 4.75881 0.744141Z" />
                      </mask>
                      <path
                        d="M4.75881 0.744141L6.00737 1.26904L7.09775 -1.32459L4.39035 -0.559182L4.75881 0.744141ZM4.65725 1.00586L3.3833 0.546023L3.38328 0.546061L4.65725 1.00586ZM7.87698 7.8623L7.41718 9.13627L7.41727 9.13631L7.87698 7.8623ZM11.1465 7.97754L12.3951 8.50231L13.4849 5.90926L10.7782 6.67418L11.1465 7.97754ZM4.3926 10.9365L3.93273 12.2105L3.9328 12.2105L4.3926 10.9365ZM1.17288 4.08008L-0.101093 3.62028L-0.101101 3.6203L1.17288 4.08008ZM4.75881 0.744141L3.51026 0.219241C3.46322 0.331127 3.42125 0.440871 3.3833 0.546023L4.65725 1.00586L5.93121 1.4657C5.95717 1.39376 5.98227 1.32874 6.00737 1.26904L4.75881 0.744141ZM4.65725 1.00586L3.38328 0.546061C2.12511 4.03208 3.93113 7.8781 7.41718 9.13627L7.87698 7.8623L8.33678 6.58834C6.25794 5.83805 5.18092 3.54452 5.93122 1.46566L4.65725 1.00586ZM7.87698 7.8623L7.41727 9.13631C8.78743 9.63071 10.2144 9.64841 11.5148 9.2809L11.1465 7.97754L10.7782 6.67418C10.0001 6.89406 9.15321 6.88293 8.33668 6.5883L7.87698 7.8623ZM11.1465 7.97754L9.8979 7.45276C9.07854 9.4023 6.86452 10.3888 4.8524 9.66255L4.3926 10.9365L3.9328 12.2105C7.30872 13.4289 11.0202 11.7736 12.3951 8.50231L11.1465 7.97754ZM4.3926 10.9365L4.85248 9.66258C2.77375 8.91219 1.69666 6.61855 2.44686 4.53985L1.17288 4.08008L-0.101101 3.6203C-1.35916 7.10624 0.447038 10.9522 3.93273 12.2105L4.3926 10.9365ZM1.17288 4.08008L2.44685 4.53988C2.90155 3.28002 3.92317 2.38788 5.12728 2.04746L4.75881 0.744141L4.39035 -0.559182C2.38397 0.0080393 0.663236 1.50255 -0.101093 3.62028L1.17288 4.08008Z"
                        fill="#13151A"
                        mask="url(#path-1-inside-1_765_6715)"
                      />
                    </svg>
                  )}
                </span>
                <span className="sun">
                  {theme === "light" ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <circle
                        cx="5.91193"
                        cy="6.01886"
                        r="2.06791"
                        stroke="#13151A"
                        stroke-width="1.43218"
                      />
                      <path
                        d="M6.82129 10.1362L6.84222 11.817L5.17835 11.8377L5.15742 10.157L6.82129 10.1362Z"
                        fill="#13151A"
                      />
                      <path
                        d="M6.82129 0.162598L6.84222 1.84332L5.17835 1.86405L5.15742 0.183323L6.82129 0.162598Z"
                        fill="#13151A"
                      />
                      <path
                        d="M1.86377 6.82129L0.183045 6.84222L0.16232 5.17835L1.84304 5.15742L1.86377 6.82129Z"
                        fill="#13151A"
                      />
                      <path
                        d="M11.8374 6.82129L10.1567 6.84222L10.136 5.17835L11.8167 5.15742L11.8374 6.82129Z"
                        fill="#13151A"
                      />
                      <path
                        d="M2.49463 3.65674L1.29137 2.48309L2.45325 1.2919L3.65651 2.46555L2.49463 3.65674Z"
                        fill="#13151A"
                      />
                      <path
                        d="M9.54639 10.7085L8.34313 9.53485L9.50501 8.34366L10.7083 9.51731L9.54639 10.7085Z"
                        fill="#13151A"
                      />
                      <path
                        d="M8.34326 2.49463L9.51691 1.29137L10.7081 2.45325L9.53445 3.65651L8.34326 2.49463Z"
                        fill="#13151A"
                      />
                      <path
                        d="M1.29199 9.54688L2.46564 8.34362L3.65683 9.5055L2.48318 10.7088L1.29199 9.54688Z"
                        fill="#13151A"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <circle
                        cx="5.91193"
                        cy="6.0186"
                        r="2.06791"
                        stroke="#F6F6F7"
                        stroke-width="1.43218"
                      />
                      <path
                        d="M6.82129 10.136L6.84222 11.8167L5.17835 11.8374L5.15742 10.1567L6.82129 10.136Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M6.82129 0.162567L6.84222 1.84329L5.17835 1.86402L5.15742 0.183292L6.82129 0.162567Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M1.86377 6.82135L0.183045 6.84228L0.16232 5.17841L1.84304 5.15748L1.86377 6.82135Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M11.8374 6.82135L10.1567 6.84228L10.136 5.17841L11.8167 5.15748L11.8374 6.82135Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M2.49463 3.65648L1.29137 2.48283L2.45325 1.29164L3.65651 2.46529L2.49463 3.65648Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M9.54639 10.7083L8.34313 9.53466L9.50501 8.34348L10.7083 9.51712L9.54639 10.7083Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M8.34326 2.49455L9.51691 1.2913L10.7081 2.45318L9.53445 3.65643L8.34326 2.49455Z"
                        fill="#F6F6F7"
                      />
                      <path
                        d="M1.29199 9.54663L2.46564 8.34338L3.65683 9.50526L2.48318 10.7085L1.29199 9.54663Z"
                        fill="#F6F6F7"
                      />
                    </svg>
                  )}
                </span>
                <span className="toggle-slider"></span>
              </label>
            </div>
          </div>
          {smartAccount && account && (
            <button
              className="bluebtn"
              onClick={() => {
                handleShow5();
                handleClose2();
              }}
            >
              Deposit
            </button>
          )}
          {account ? (
            <button className="disconnect" onClick={disconnectWallet}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M10 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.33594 11.3337L2.0026 8.00033L5.33594 4.66699"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M2 8H10"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Disconnect
            </button>
          ) : (
            <button
              onClick={() => {
                handleClose2();
                handleShow();
              }}
              className="connectbtn"
            >
              Connect Wallet
            </button>
          )}
        </div>
      </Offcanvas>
      <Modal className="editmodal" show={show7} onHide={handleClose7} centered>
        <Modal.Header closeButton>
          <Modal.Title>sign</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mainuppercontent">
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="52"
                height="52"
                viewBox="0 0 52 52"
                fill="none"
              >
                <path
                  d="M26 47.6667C37.9662 47.6667 47.6667 37.9662 47.6667 26C47.6667 14.0338 37.9662 4.33334 26 4.33334C14.0339 4.33334 4.33337 14.0338 4.33337 26C4.33337 37.9662 14.0339 47.6667 26 47.6667Z"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 17.3333V26"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M26 34.6667H26.0217"
                  stroke="#F24CA2"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <h6>You're about to sign a transaction authorization.</h6>
          </div>
          <p className="mainparamodal">
            This signature allows us to perform gasless transactions on your
            behalf for the next 24 hours
          </p>

          <div className="bottom-btns">
            <button onClick={handleClose7} className="closebtn">
              Close
            </button>
            <button onClick={tryCreatePoolTx} className="depositbtn">
              Confirm
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Header;
